// extracted by mini-css-extract-plugin
export default {"content":"Dashboard_content__LBKYO","main":"Dashboard_main__bnJRu","info-container":"Dashboard_info-container__OwPWp","subtitle":"Dashboard_subtitle__BcMqw"};